import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { LanguageService } from '../languageService/language.service';
declare const AdverticalTVAds: any;
declare let adverticalTVAds: any;
@Injectable({
  providedIn: 'root'
})
export class AdverticalService {
  private adverticalTV;
  private device;
  constructor(private deviceService: DeviceDetectorService, private languageService: LanguageService) {
    this.device = this.deviceService.getDeviceInfo();
  }

  /** Init Advertical TV SDK and Register  */
  init() {
    this.adverticalTV = new AdverticalTVAds({
      baseUrl: environment.adverticalTVUrl,
      apiKey: environment.adverticalApiKey,
      active: environment.enableAds,
      showVideoStarts: true
    });

    adverticalTVAds = this.adverticalTV;

    let config = {
      data: {
        set: {
          device: "Web",
          language: this.languageService.findLanguageInfo(this.languageService.getLanguage(), "iso639_1"),
          os: this.device.browser
        }
      }
    };

    return new Promise(resolve => {
      this.adverticalTV.register(config, function () {
        resolve(null);
      });
    });
  }


  /** Get Banner Ad for an area
  * @param areaName Name of an area
  * @param areadId Element id name
  * @param canClose Boolean true in case you want to add close button in the Banner
  */
  getBanner(areaName, areadId, canClose) {
    this.adverticalTV.getAd(areaName, areadId, canClose, function (resp) { });
  }

  /** Get Video Ad for an area
  * @param areaName Name of an area
  * @param areadId Element id name
  */
  getVideoAd(areaName, areadId) {
    return new Promise(resolve => {
      this.adverticalTV.getAd(areaName, areadId, false, function (resp) {
        resolve(null);
      });
    });
  }
}